import store from '@/store'
import config from '@/config/nimConfig'
// import util from '../../utils'
import {formatMsg} from './msgs'
import { get_tUser } from "@/assets/js/utils"

// 接收消息监听
export const onChatroomMsgs = ({state, commit}, msgs) => {
  let c_t = get_tUser().c_t || '';
  let currChatroomId = (state && state.currChatroomId) ? state.currChatroomId : null
  if(!currChatroomId || !msgs){
    return
  }
  if (!Array.isArray(msgs)) {
    msgs = [msgs]
  }
  msgs = msgs.map(msg => {
    msg.custom = msg.custom ? JSON.parse(msg.custom) : {};
    msg.content = msg.content ? JSON.parse(msg.content) : {};
    msg.fromCustom = msg.fromCustom ? JSON.parse(msg.fromCustom) : {};
    return formatMsg(msg)
  })
  // 非正式环境，实时显示消息
  if(process.env.VUE_APP_ENV !== 'prod'){
    console.log('onChatroomMsgs>>>>', msgs)
  }
  if (currChatroomId) {
    // 文字显示，只处理文字消息
    let textMessages = msgs.filter(item=> (item.type === 'text' || item.type==='custom' && item.subType === 1) )
    if(textMessages.length){
      commit('updateCurrChatroomMsgs', {
        type: 'put',
        msgs: textMessages
      })
    }

    // 系统消息相关处理
    let notificationMessage = msgs.filter(item=> item.type === 'notification' && item.chatroomId == currChatroomId); //当前打开的聊天室系统消息
    notificationMessage.forEach(message=>{
      let { type, to=[], duration } = message.attach
      to.forEach(user=>{
        // 处理禁言/解除禁言
        if(type === 'addTempMute' || type === 'removeTempMute'){
          // 判断是否是自己被禁言
          if(to.includes(c_t)){
            commit('updateNimState', {
              state: 'currMyChatroomInfo',
              value: {
                ...state.currMyChatroomInfo,
                tempMuted: type === 'addTempMute'
              }
            })
          }
        }
        
      })
    })
    
    // 自定义消息处理
    let customMsgs = msgs.filter(item=> item.type === 'custom')
    console.log(customMsgs,"===================>收到自定义消息")
    if (customMsgs.length) {
      resetCustomMsg(customMsgs[0])
    }
    
    // 如果有人订阅消息
    if(state.chatroomMessageListener){
      Object.values(state.chatroomMessageListener).forEach(callBack=>{
        if(callBack){
          callBack(msgs)
        }
      })
    }

  }
}
// 发送成功回调
function onSendMsgDone (store, error, msg) {
  // console.log('onSendMsgDone',store, msg)
  // store.dispatch('nim/hideLoading')
  if (error) {
    // alert(error.message)
    console.log('onSendMsgDone error',error)
    return
  }
  onChatroomMsgs(store, [msg])
}
// 发送消息
export const sendChatroomMsg = (store, obj) =>{
  let {state, commit} = store
  const chatroom = window ? window.chatroom : null
  obj = obj || {}
  let type = obj.type || ''
  // store.dispatch('nim/showLoading')
  if(!chatroom){
    return
  }
  switch (type) {
    case 'text':
      chatroom.sendText({
        text: obj.text,
        custom: JSON.stringify(obj.custom || {}),
        pushContent: obj.pushContent || null,
        done: (error, msg)=>{
          onSendMsgDone(store, error, msg)
        }
      })
      break
    case 'custom':
      chatroom.sendCustomMsg({
        content: JSON.stringify(obj.content || {}),
        text: obj.text,
        pushContent: obj.pushContent || null,
        done:  (error, msg)=>{
          onSendMsgDone(store, error, msg)
        }
      })
  }
}
// 发送机器人消息
export function sendChatroomRobotMsg (store, obj) {
  let {state, commit} = store
  const chatroom = window ? window.chatroom : null
  if(!chatroom){
    return
  }
  let {type, robotAccid, content, params, target, body} = obj
  if (type === 'text') {
    chatroom.sendRobotMsg({
      robotAccid,
      content: {
        type: 'text',
        content,
      },
      body,
      done: (error, msg)=>{
        onSendMsgDone(store, error, msg)
      }
    })
  } else if (type === 'welcome') {
    chatroom.sendRobotMsg({
      robotAccid,
      content: {
        type: 'welcome',
      },
      body,
      done: (error, msg)=>{
          onSendMsgDone(store, error, msg)
        }
    })
  } else if (type === 'link') {
    chatroom.sendRobotMsg({
      robotAccid,
      content: {
        type: 'link',
        params,
        target
      },
      body,
      done: (error, msg)=>{
          onSendMsgDone(store, error, msg)
        }
    })
  }
}
// 发送文件消息
export function sendChatroomFileMsg (store, obj) {
  let {state, commit, dispatch} = store
  const chatroom = window ? window.chatroom : null
  if(!chatroom){
    return
  }
  let {fileInput} = Object.assign({}, obj)
  let type = 'file'
  if (/\.(png|jpg|bmp|jpeg|gif)$/i.test(fileInput.value)) {
    type = 'image'
  } else if (/\.(mov|mp4|ogg|webm)$/i.test(fileInput.value)) {
    type = 'video'
  }
  dispatch('showLoading')
  chatroom.sendFile({
    type,
    fileInput,
    uploadprogress: function (data) {
      // console.log(data.percentageText)
    },
    uploaderror: function () {
      fileInput.value = ''
      console && console.log('上传失败')
    },
    uploaddone: function(error, file) {
      fileInput.value = ''
      // console.log(error);
      // console.log(file);
    },
    beforesend: function (msg) {
      // console && console.log('正在发送消息, id=', msg);
    },
    done: (error, msg) => {
      onSendMsgDone(store, error, msg)
    }
  })
}

// 获取历史消息
export const getChatroomHistoryMsgs = ({state, commit, dispatch}, data ={}) => {
  const chatroom = window ? window.chatroom : null
  if (chatroom) {
    let limit = data.limit || config.localMsglimit || 50;
    // 同步获取数据状态
    commit('updateNimState', { state: 'getCurrChatroomHistoryState', value: true})

    let options = {
      limit,
      msgTypes: data.msgTypes || ['text'],
      done: (error, obj) => {
        // console.log('getChatroomHistoryMsgs=>>>', obj)
        // 同步获取数据状态
        commit('updateNimState', { state: 'getCurrChatroomHistoryState', value: false})
        if (obj.msgs) {
          if (!obj.msgs.length) {
            commit('setNoMoreHistoryMsgs')
          } else {
            let msgs = obj.msgs.map(msg => {
              msg.custom = msg.custom ? JSON.parse(msg.custom) : {};
              msg.fromCustom = msg.fromCustom ? JSON.parse(msg.fromCustom) : {};
              msg.content = msg.content ? JSON.parse(msg.content) : {};
              return formatMsg(msg)
            })
            if(msgs.length < limit){
              commit('setNoMoreHistoryMsgs')
            }
            commit('updateCurrChatroomMsgs', {
              type: 'concat',
              msgs
            })
            if(data.callBack){
              data.callBack(msgs)
            }
          }
        }
      }
    }
    if(data.timetag || state.currChatroomLastMsg){
      options.timetag = (data.timetag || state.currChatroomLastMsg.time);
    }
    chatroom.getHistoryMsgs(options)
  }
}
// 获取反转的历史消息
export const getChatroomReverseHistoryMsgs = ({state, commit, dispatch}, data ={}) => {
  const chatroom = window ? window.chatroom : null
  if (chatroom) {
    let limit = data.limit || config.localMsglimit || 100;

    // if(data.timetag || state.currChatroomLastMsg){
    //   options.timetag = (data.timetag || state.currChatroomLastMsg.time);
    // }
    return new Promise((resolve, reject)=>{
      chatroom.getHistoryMsgs({
        limit,
        timetag: data.timetag || '',
        msgTypes: data.msgTypes || ['text'],
        reverse: true,
        done: (error, obj) => {
          console.log('getChatroomReverseHistoryMsgs=>>>', obj)
          if (obj.msgs) {
            let msgs = obj.msgs.map(msg => {
              msg.custom = msg.custom ? JSON.parse(msg.custom) : {};
              msg.content = msg.content ? JSON.parse(msg.content) : {};
              return formatMsg(msg)
            })
            resolve(msgs)
          }else{
            resolve([])
          }
        }
      })

    })
  }
}


// 处理自定义消息
function resetCustomMsg(msg) {
  let subType = msg.subType
  switch (subType) {
    // 用户投递通知
    case 1: {
      cvDelivery(msg);break;
    }
    // // 宣讲人/管理员回复了消息
    // case 2: {
    //   managerReplyMsg(msg);break;
    // }
    // // 用户进入/离开直播频道
    // case 3: {
    //   intoOrLeaveMsg(msg); break;
    // }
    // // 主讲人/管理员精选了评论
    // case 4: {
    //   managerLikeReply(msg);break;
    // }
    case 5: {
      hostStartLiveCallback(msg);break;
    }
  }
}

// 监听到b端主播开播或者下播
const hostStartLiveCallback = async (msg) => {
  await store.dispatch('live/getRtcTokenActionsFun')
  const { status } = msg.content
  const { client, token, options } = store.state.live

  // 主播开播
  if (status) {
    // 用户加入频道
    try {
      await client.join(options.appId, options.channel, token, options.uid)
    } catch (e) {
      console.log('加入频道（用户） 错误：', e)
    }
  // 主播下播
  } else {
    // 用户离开频道
    try {
      await client.leave()
    } catch (e) {
      console.log('离开频道（用户） 错误：', e)
    }
  }
}

// 用户投递简历处理
function cvDelivery(msg) {
  console.log(msg,"=====================>有人投递了")
  let content = msg.content
  let { job_token } = content
  let c_t = get_tUser().c_t || '';
  // 直播的在线职位列表
  let liveDetailJobList = JSON.parse(JSON.stringify(store.state.live.liveDetailJobList)).map(item => {
    if (item.token === job_token) {
      item.delivery_count = item.delivery_count + 1
      // 判断是否是自己发的，是就说明是自己投递的
      if(msg.from === c_t){
        item.delivery_status = true
      }
    }
    return item
  })
  // 更新当前职位的投递人数
  store.commit('live/setLiveDetailJobList', liveDetailJobList)
}